export const environment = {
    production: false,
    checkUser:'/check_user',
    signUp:'/signup',
    base:'https://coronation-api.test-draytechits.com',
    submitPayment: '/submit_payment',
    checkPaymentStatus:'/check_payment_status',
    checkApplicationStatus:'/check_application_status',
};
